import { isAvailable, FDealType, FOfferType } from '../../../../../../../packages/JsonQuery';
import { IFilterSet, TAllFilter } from 'shared/types/filters';

export const OTHER_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailable(FDealType.Any, FOfferType.Any),
    list: ['withNeighbors', 'publicationDate', 'containWords', 'excludeWords', 'contact', 'offerId'],
  },
];
